import React from 'react'

const sources = (src: string) => {
  const base = `${src}?w=50&q=90`
  return [`${base}&fm=webp`, `${base}&fm=avif`]
}

/**
 * Country selector component flag icon.
 * Displays the flag of a country with an alt text.
 */
export const CountrySelectorFlagIcon = React.memo(function ({
  src,
  alt
}: {
  readonly src: string
  readonly alt: string
}) {
  const [webpSrc, avifSrc] = sources(src)
  return (
    <picture>
      <source srcSet={avifSrc} type="image/avif" />
      <source srcSet={webpSrc} type="image/webp" />
      <img src={webpSrc} alt={alt} className="h-3 w-5" />
    </picture>
  )
})
